const fadeInPage = () => {
  function fader() {
    if (!window.AnimationEvent) {
      return;
    }
    const fader = document.querySelector('#fader');
    if (fader === null) { return };
    fader.classList.add('fade-out');
  }

  document.addEventListener('DOMContentLoaded', function() {
    if (!window.AnimationEvent) {
      return;
    }

    const fader = document.querySelector('#fader');
    if (fader === null) { return };

    const anchors = document.getElementsByTagName('a');

    for (var idx = 0; idx < anchors.length; idx += 1) {
      if (anchors[idx].hostname !== window.location.hostname) {
        continue;
      }

      anchors[idx].addEventListener('click', function(event) {
        var anchor = event.currentTarget;

        var listener = function() {
          window.location = anchor.href;
          fader.removeEventListener('animationend', listener);
        };
        fader.addEventListener('animationend', listener);

        event.preventDefault();
        fader.classList.add('fade-in');
      });
    }
  });

  window.addEventListener('pageshow', function(event) {
    if (!event.persisted) {
      return;
    }
    const fader = document.querySelector('#fader');
    if (fader === null) { return };
    fader.classList.remove('fade-in');
  });

  fader();
};

export default fadeInPage;
